import cookie from 'js-cookie'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useStore } from 'vuex'

import { normalizeAdvertiser } from '@/lib/adapters/advertiser.adapter'
import { request } from '@/lib/services'
import type { AdvertiserType } from '@/lib/types/advertiser.types'

export const useAdvertiserStore = defineStore('advertiser', () => {
  const isLoading = ref(false)
  const isFetched = ref(false)
  const error = ref<Error | null>(null)

  const advertiser = ref<AdvertiserType>()
  const legacyStore = useStore()

  const fetchAdvertiser = async (id: number) => {
    const advertiserId = id

    isLoading.value = true
    error.value = null
    try {
      const response = await request.get(`/advertiser/stores/${advertiserId}`)
      advertiser.value = normalizeAdvertiser(response.data)
      cookie.set('advertiserId', String(advertiserId))
      isFetched.value = true

      await legacyStore.dispatch('shop/setShopFromPinia', response.data, { root: true })
    } catch (err) {
      error.value = err as Error
    } finally {
      isLoading.value = false
    }
  }

  return {
    advertiser,
    isLoading,
    isFetched,
    error,
    fetchAdvertiser,
  }
})
